import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Button,
  CardContent,
  Snackbar,
  Alert,
} from "@mui/material";
import { API_URL } from "../../../Config/api";

const cancelby = [
  { value: 1, label: "Spero" },
  { value: 2, label: "Customer" },
];

const Cancellation = ({ eventID, subSrvID, onClose }) => {
  const accessToken = localStorage.getItem("token");

  // States
  const [cancelReason, setCancelReason] = useState([]);
  const [selectedCancelReason, setSelectedCancelReason] = useState("");
  const [selectedReasonID, setSelectedReasonID] = useState("");
  const [amount, setAmount] = useState("0");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [remark, setRemark] = useState("");
  const [eventCancel, setEventCancel] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [errors, setErrors] = useState({});

const totalSessions = eventCancel?.total_session_count || 0;

const filteredCancelTypes = useMemo(() => {
  const options = [
    { value: "1", label: "Service" },
    { value: "2", label: "Session" },
  ];

  // Case 1: Agar session count exact 1 hai, toh Session option mat dikhao
  if (totalSessions === 1) {
    return options.filter((opt) => opt.value === "1");
  }

  // Case 2: Agar 1 se zyada hai, toh dono options dikhao
  return options;
}, [totalSessions]);



  // API: Get Cancellation Reasons
  useEffect(() => {
    if (selectedReasonID) {
      fetch(
        `${API_URL}/web/cancellation_reason_follow_up_list/${selectedReasonID}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      )
        .then((res) => res.json())
        .then((data) => setCancelReason(data))
        .catch((err) => console.error("Error fetching reasons:", err));
    }
  }, [selectedReasonID, accessToken]);

useEffect(() => {
    if (eventID) {
      fetch(`${API_URL}/web/service_cancellation/${eventID}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
        .then((res) => res.json())
        .then((data) => {
          // Aapke naye JSON ke hisaab se mapping
          const eventData = data.event_data || (Array.isArray(data) ? data[0] : data);
          
          // Dono keys check karein (T capital aur small t)
          const sessionCount = eventData?.Total_session || eventData?.job_closure?.total_session || 0;
          
          console.log("Final Session Count Detected:", sessionCount);

          setEventCancel({
            ...eventData,
            total_session_count: Number(sessionCount) // Humne ise ek common key mein save kar liya
          });
        })
        .catch((err) => console.error("Error fetching service data:", err));
    }
  }, [eventID, accessToken]);

  // API: Get Session Amount
  useEffect(() => {
    if (selectedOption === "2" && eventID && fromDate && toDate) {
      fetch(
        `${API_URL}/web/get_session_amt/${eventID}/${subSrvID}/${fromDate}/${toDate}/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      )
        .then((res) => res.json())
        .then((data) => setAmount(data))
        .catch((err) => console.error("Error fetching amount:", err));
    }
  }, [eventID, subSrvID, fromDate, toDate, selectedOption, accessToken]);

  const validateFields = (isSession = false) => {
    const newErrors = {};
    if (!selectedOption) newErrors.selectedOption = "Required";
    if (!remark || remark.trim().length < 15)
      newErrors.remark = "Remark must be at least 15 characters";
    if (!selectedCancelReason)
      newErrors.selectedCancelReason = "Reason is required";
    if (!selectedReasonID) newErrors.selectedReasonID = "Required";

    if (isSession) {
      if (!fromDate) newErrors.fromDate = "Required";
      if (!toDate) newErrors.toDate = "Required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleAction = async (e) => {
    e.preventDefault();
    const isSession = selectedOption === "2";
    if (!validateFields(isSession)) return;

    const url = isSession
      ? `${API_URL}/web/session_cancellation/`
      : `${API_URL}/web/service_cancellation/${eventID}`;

    const requestData = isSession
      ? {
          eve_id: eventID,
          sub_srv_id: subSrvID,
          cancellation_by: selectedReasonID,
          reason: selectedCancelReason,
          start_date_time: fromDate,
          end_date_time: toDate,
          remark: remark,
        }
      : {
          event_id: eventID,
          cancellation_by: selectedReasonID,
          reason: selectedCancelReason,
          remark: remark,
        };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();


      if (response.ok) {
     
        setSnackbarMessage(
          `${isSession ? "Session" : "Service"} Cancelled successfully!`
        );
        setSnackbarSeverity("success");
        setOpenSnackbar(true);

      
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
  
        setSnackbarMessage(result.msg || "Error processing request");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      setSnackbarMessage("Something went wrong. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  return (
    <Box>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              size="small"
              label="Cancellation Type"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              error={!!errors.selectedOption}
              helperText={errors.selectedOption}
            >
              {filteredCancelTypes.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              size="small"
              label="Cancellation by"
              value={selectedReasonID}
              onChange={(e) => setSelectedReasonID(e.target.value)}
              error={!!errors.selectedReasonID}
              helperText={errors.selectedReasonID}
            >
              {cancelby.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              size="small"
              label="Cancellation Reason"
              value={selectedCancelReason}
              onChange={(e) => setSelectedCancelReason(e.target.value)}
              error={!!errors.selectedCancelReason}
              helperText={errors.selectedCancelReason}
            >
              {cancelReason.map((opt) => (
                <MenuItem
                  key={opt.cancelation_reason_id}
                  value={opt.cancelation_reason_id}
                >
                  {opt.cancelation_reason}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {selectedOption === "2" && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    type="date"
                    fullWidth
                    size="small"
                    label="From Date"
                    InputLabelProps={{ shrink: true }}
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    error={!!errors.fromDate}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    type="date"
                    fullWidth
                    size="small"
                    label="To Date"
                    InputLabelProps={{ shrink: true }}
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    error={!!errors.toDate}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Amount to be Refunded: ₹
              {selectedOption === "2"
                ? amount
                : eventCancel?.payment?.final_amount || 0}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              label="Remark"
              placeholder="Min 15 characters..."
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              error={!!errors.remark}
              helperText={errors.remark}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "rgb(52, 123, 137)",
                borderRadius: "12px",
              }}
              onClick={handleAction}
            >
              {selectedOption === "2" ? "Cancel Session" : "Cancel Service"}
            </Button>
          </Grid>
        </Grid>
      </CardContent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert severity={snackbarSeverity} variant="filled">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Cancellation;
